var $ = window.jQuery
import moment from "moment"

$(document).ready(function() {
	if($('.waiting-screen').length !== 0) {
		let webinar_start_time = $('.waiting-screen').data('time')

		setInterval(function() {
			updateTime(webinar_start_time)
		}, 1000);
	}
});

function updateTime(time) {	
	var eventTime = time * 1000
	var currentTime = new Date().getTime()
	var diffTime = moment(eventTime).diff(currentTime, 'seconds')
	var duration = moment.duration(diffTime, 'seconds')

	console.log(duration.days())

	$('.block-webinar .waiting-screen .time').css('opacity', 1);

	if (duration.months() < 1) {
		$('.block-webinar .waiting-screen .time .month').remove()

		if(duration.days() < 10) {
			$('.block-webinar .waiting-screen .time .day .number').text('0' + duration.days())
		} else {
			$('.block-webinar .waiting-screen .time .day .number').text(duration.days())
		}

		if(duration.hours() < 10) {
			$('.block-webinar .waiting-screen .time .hour .number').text('0' + duration.hours())
		} else {
			$('.block-webinar .waiting-screen .time .hour .number').text(duration.hours())
		}

		if(duration.minutes() < 10) {
			$('.block-webinar .waiting-screen .time .minute .number').text('0' + duration.minutes())
		} else {
			$('.block-webinar .waiting-screen .time .minute .number').text(duration.minutes())
		}

		if(duration.seconds() < 10) {
			$('.block-webinar .waiting-screen .time .second .number').text('0' + duration.seconds())
		} else {
			$('.block-webinar .waiting-screen .time .second .number').text(duration.seconds())
		}
	} else {
		$('.block-webinar').addClass('eta-over-month')

		if(duration.months() < 10) {
			$('.block-webinar .waiting-screen .time .month .number').text('0' + duration.months())
		} else {
			$('.block-webinar .waiting-screen .time .month .number').text(duration.months())
		}

		if(duration.days() < 10) {
			$('.block-webinar .waiting-screen .time .day .number').text('0' + duration.days())
		} else {
			$('.block-webinar .waiting-screen .time .day .number').text(duration.days())
		}
	}
}